import React, { useEffect, useState, useRef, lazy } from 'react';
import { useReveal } from '../lib/useReveal';
const PREVIEWS = [{
  src: 'https://cdn.magicpatterns.com/uploads/sjNkrbFjDuZuuJhSyNJRVy/PAGINA_3.png',
  tomo: 'TOMO 1',
  title: '¿Qué es Reiki realmente?'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/i2toEWePsVJJFCifHhUN8f/PAGINA_4.png',
  tomo: 'TOMO 1',
  title: 'Historia moderna del Reiki'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/5suhChWnjo6rVyzCtARXsX/PAGINA_4.png',
  tomo: 'TOMO 2',
  title: 'Chakra Raíz · Seguridad y estabilidad'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/4mY6e22nmHDibZxEhc9sq2/PAGINA_5.png',
  tomo: 'TOMO 2',
  title: 'Chakra Sacro · Emociones y creatividad'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/etuR5vz9vvzfQzq2vRp3jy/PAGINA_2.png',
  tomo: 'TOMO 3',
  title: 'El rol del terapeuta Reiki'
}];
export function CoursePreviewSection() {
  const [ref1, vis1] = useReveal();
  const [active, setActive] = useState<number | null>(null);
  const [current, setCurrent] = useState(0);
  const trackRef = useRef<HTMLDivElement>(null);
  const scrollToIndex = (idx: number) => {
    if (!trackRef.current) return;
    const track = trackRef.current;
    const item = track.children[idx] as HTMLElement | undefined;
    if (item) {
      track.scrollTo({
        left: item.offsetLeft - (track.offsetWidth - item.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }
  };
  const handleScroll = () => {
    if (!trackRef.current) return;
    const track = trackRef.current;
    const center = track.scrollLeft + track.offsetWidth / 2;
    let closest = 0;
    let closestDist = Infinity;
    Array.from(track.children).forEach((child, idx) => {
      const el = child as HTMLElement;
      const elCenter = el.offsetLeft + el.offsetWidth / 2;
      const dist = Math.abs(center - elCenter);
      if (dist < closestDist) {
        closestDist = dist;
        closest = idx;
      }
    });
    setCurrent(closest);
  };
  const next = () => {
    const nextIdx = Math.min(current + 1, PREVIEWS.length - 1);
    scrollToIndex(nextIdx);
  };
  const prev = () => {
    const prevIdx = Math.max(current - 1, 0);
    scrollToIndex(prevIdx);
  };
  useEffect(() => {
    // Center the first item on mount
    scrollToIndex(0);
  }, []);
  return <section className="bg-[#faf5fc] py-12 md:py-16 px-0 sm:px-6 border-t border-[#e8d5f0] overflow-hidden" data-id="element-147">
      <div className="container mx-auto max-w-6xl" data-id="element-148">
        <div ref={ref1} className={`reveal text-center mb-8 px-5 ${vis1 ? 'is-visible' : ''}`} data-id="element-149">
          <span className="text-[#c9a14d] text-xs font-bold tracking-[0.25em] uppercase mb-2 block" data-id="element-150">
            👁️ Mirá adentro
          </span>
          <h2 className="text-3xl md:text-5xl font-bold text-[#3d2a5f] mb-3" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-151">
            El Curso Por Dentro
          </h2>
          <p className="text-[#6b5a85] text-base md:text-lg max-w-2xl mx-auto" data-id="element-152">
            Cada página fue diseñada con amor. Material profesional, visual y
            profundo para que tu camino sea claro desde el primer día.
          </p>
        </div>

        {/* Carousel */}
        <div className="relative" data-id="element-153">
          {/* Prev / Next buttons (desktop) */}
          <button onClick={prev} aria-label="Anterior" disabled={current === 0} className="hidden md:flex absolute left-2 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-white shadow-[0_8px_20px_rgba(61,42,95,0.15)] border border-[#e8d5f0] items-center justify-center text-[#3d2a5f] hover:bg-[#c9a14d] hover:text-white hover:border-[#c9a14d] transition-all disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-[#3d2a5f]" data-id="element-154">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" data-id="element-155">
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" data-id="element-156" />
            </svg>
          </button>
          <button onClick={next} aria-label="Siguiente" disabled={current === PREVIEWS.length - 1} className="hidden md:flex absolute right-2 top-1/2 -translate-y-1/2 z-20 w-11 h-11 rounded-full bg-white shadow-[0_8px_20px_rgba(61,42,95,0.15)] border border-[#e8d5f0] items-center justify-center text-[#3d2a5f] hover:bg-[#c9a14d] hover:text-white hover:border-[#c9a14d] transition-all disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:text-[#3d2a5f]" data-id="element-157">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24" data-id="element-158">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" data-id="element-159" />
            </svg>
          </button>

          {/* Track */}
          <div ref={trackRef} onScroll={handleScroll} className="flex gap-4 md:gap-6 overflow-x-auto snap-x snap-mandatory scroll-smooth pb-6 px-[15%] sm:px-[20%] md:px-[25%]" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-160">
            {PREVIEWS.map((p, idx) => <button key={idx} onClick={() => {
            if (idx === current) {
              setActive(idx);
            } else {
              scrollToIndex(idx);
            }
          }} className={`group relative flex-none w-[70%] sm:w-[55%] md:w-[40%] lg:w-[30%] snap-center bg-white rounded-2xl overflow-hidden border shadow-sm transition-all duration-500 text-left ${current === idx ? 'border-[#c9a14d] shadow-[0_20px_50px_rgba(61,42,95,0.2)] scale-100' : 'border-[#e8d5f0] scale-90 opacity-60'}`} data-id="element-161">
                <div className="aspect-[3/4] overflow-hidden bg-[#f3e9f7]" data-id="element-162">
                  <img src={p.src} alt={`${p.tomo} — ${p.title}`} className="w-full h-full object-cover" loading="lazy" data-id="element-163" />
                </div>
                <div className="p-3 sm:p-4 border-t border-[#e8d5f0]" data-id="element-164">
                  <span className="text-[#c9a14d] text-[10px] font-bold tracking-widest uppercase block mb-1" data-id="element-165">
                    {p.tomo}
                  </span>
                  <p className="text-[#3d2a5f] text-xs sm:text-sm font-semibold leading-tight" data-id="element-166">
                    {p.title}
                  </p>
                </div>
              </button>)}
          </div>

          {/* Dots */}
          <div className="flex justify-center gap-2 mt-2" data-id="element-167">
            {PREVIEWS.map((_, idx) => <button key={idx} onClick={() => scrollToIndex(idx)} aria-label={`Ir a página ${idx + 1}`} className={`h-2 rounded-full transition-all ${current === idx ? 'bg-[#c9a14d] w-8' : 'bg-[#e8d5f0] w-2 hover:bg-[#c9a14d]/40'}`} data-id="element-168" />)}
          </div>
        </div>
      </div>

      {/* Lightbox */}
      {active !== null && <div onClick={() => setActive(null)} className="fixed inset-0 z-[100] bg-[#3d2a5f]/90 backdrop-blur-sm flex items-center justify-center p-4" data-id="element-169">
          <button onClick={() => setActive(null)} aria-label="Cerrar" className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors" data-id="element-170">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" data-id="element-171">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" data-id="element-172" />
            </svg>
          </button>
          <img src={PREVIEWS[active].src} alt={PREVIEWS[active].title} onClick={e => e.stopPropagation()} className="max-w-full max-h-[90vh] object-contain rounded-lg shadow-2xl" data-id="element-173" />
        </div>}

      <style data-id="element-174">{`
        .reveal > .relative > div::-webkit-scrollbar { display: none; }
      `}</style>
    </section>;
}